import axiosInstance from "auth/FetchInterceptor";
import {
  RECORD_PAYMENT,
  COMPLETE_TRIP,
  GET_PAYMENT_SUMMARY,
  GET_PAYMENT_HISTORY,
} from "constants/ApiConstant";

const OrderPaymentService = {};

OrderPaymentService.recordPayment = function (data) {
  return axiosInstance.post(RECORD_PAYMENT, data);
};

OrderPaymentService.completeTrip = function (tripId) {
  return axiosInstance.post(`${COMPLETE_TRIP}/${tripId}`);
};

OrderPaymentService.getPaymentSummary = function (orderId) {
  return axiosInstance.get(`${GET_PAYMENT_SUMMARY}/${orderId}`);
};

OrderPaymentService.getPaymentHistory = function (orderId) {
  return axiosInstance.get(`${GET_PAYMENT_HISTORY}/${orderId}`);
};

export default OrderPaymentService;